import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_clipboard.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-1c8cd46b")

_pushScopeId("data-v-1c8cd46b")
const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row items-center gap-1 mb-4" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    class: "w-6 h-6"
  }),
  /*#__PURE__*/_createVNode("h2", { class: "text-black-lp-200 font-bold" }, "Detail Ursa")
], -1)
const _hoisted_3 = { class: "flex flex-col gap-2 mb-4" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", {
  class: "text-sm text-gray-lp-300 font-bold",
  style: {"line-height":"100%","letter-spacing":"-2%"}
}, " Kode Ursa ", -1)
const _hoisted_5 = {
  class: "text-black-lp-200 font-semibold",
  style: {"line-height":"100%","letter-spacing":"-2%"}
}
const _hoisted_6 = { class: "flex flex-col gap-2 mb-4" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", {
  class: "text-sm text-gray-lp-300 font-bold",
  style: {"line-height":"100%","letter-spacing":"-2%"}
}, " 3LC ", -1)
const _hoisted_8 = {
  key: 0,
  style: {"line-height":"100%"}
}
const _hoisted_9 = {
  key: 1,
  class: "chips-container"
}
const _hoisted_10 = { class: "flex flex-col gap-2 mb-4" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", {
  class: "text-sm text-gray-lp-300 font-bold",
  style: {"line-height":"100%","letter-spacing":"-2%"}
}, " Kecamatan, Kota ", -1)
const _hoisted_12 = {
  key: 0,
  style: {"line-height":"100%"}
}
const _hoisted_13 = {
  key: 1,
  class: "chips-container"
}
const _hoisted_14 = { class: "flex flex-col gap-2" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", {
  class: "text-sm text-gray-lp-300 font-bold",
  style: {"line-height":"100%","letter-spacing":"-2%"}
}, " Kode POS ", -1)
const _hoisted_16 = {
  key: 0,
  style: {"line-height":"100%"}
}
const _hoisted_17 = {
  key: 1,
  class: "chips-container"
}
const _hoisted_18 = { class: "card" }
const _hoisted_19 = { class: "flex flex-col gap-2 mb-4" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "text-sm text-gray-lp-300" }, "Status", -1)
const _hoisted_21 = { class: "flex flex-col gap-2 mb-4" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "text-sm text-gray-lp-300" }, "Tanggal dibuat", -1)
const _hoisted_23 = { class: "date" }
const _hoisted_24 = { class: "actor" }
const _hoisted_25 = { class: "flex flex-col gap-2 mb-4" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "text-sm text-gray-lp-300" }, "Tanggal diperbarui", -1)
const _hoisted_27 = { class: "date" }
const _hoisted_28 = { class: "actor" }
const _hoisted_29 = { class: "flex flex-col gap-2" }
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "date" }, "Status Ursa", -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "guide" }, "Klik tombol dibawah untuk mengaktifkan atau menonaktifkan status. ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ToggleV2 = _resolveComponent("ToggleV2")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    customClass: "pl-4 detail-ursa",
    title: _ctx.ursaCodeTitle,
    onBack: _ctx.goBack,
    loading: _ctx.isLoadingFetch,
    error: _ctx.isError,
    errorType: _ctx.errorCause,
    onTryAgain: _ctx.getUrsaCodeDetail,
    verticalSeparator: false,
    headerNewLayout: ""
  }, {
    data: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$route.params.id), 1)
        ]),
        _createVNode("div", _hoisted_6, [
          _hoisted_7,
          (!_ctx.threeLetterCodeList.length)
            ? (_openBlock(), _createBlock("div", _hoisted_8, " - "))
            : (_openBlock(), _createBlock("div", _hoisted_9, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.threeLetterCodeList, (lc, index) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "chips",
                    key: `lc-${index}`
                  }, _toDisplayString(lc), 1))
                }), 128))
              ]))
        ]),
        _createVNode("div", _hoisted_10, [
          _hoisted_11,
          (!_ctx.areaList.length)
            ? (_openBlock(), _createBlock("div", _hoisted_12, " - "))
            : (_openBlock(), _createBlock("div", _hoisted_13, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.areaList, (area, index) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "chips",
                    key: `area-${index}`
                  }, _toDisplayString(area), 1))
                }), 128))
              ]))
        ]),
        _createVNode("div", _hoisted_14, [
          _hoisted_15,
          (!_ctx.postalCodeList.length)
            ? (_openBlock(), _createBlock("div", _hoisted_16, " - "))
            : (_openBlock(), _createBlock("div", _hoisted_17, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.postalCodeList, (pc, index) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "chips",
                    key: `pc-${index}`
                  }, _toDisplayString(pc), 1))
                }), 128))
              ]))
        ])
      ])
    ]),
    "sub-data": _withId(() => [
      _createVNode("div", _hoisted_18, [
        _createVNode("div", _hoisted_19, [
          _hoisted_20,
          _createVNode("div", {
            class: ["badge", [
              {'active': _ctx.ursaCodeDetailData.isActive},
              {'inactive': !_ctx.ursaCodeDetailData.isActive},
            ]]
          }, _toDisplayString(_ctx.ursaCodeDetailData.isActive ? 'Aktif' : 'Tidak aktif'), 3)
        ]),
        _createVNode("div", _hoisted_21, [
          _hoisted_22,
          _createVNode("div", _hoisted_23, _toDisplayString(_ctx.createdAt), 1),
          _createVNode("div", _hoisted_24, _toDisplayString(_ctx.ursaCodeDetailData.createdByName || "-"), 1)
        ]),
        _createVNode("div", _hoisted_25, [
          _hoisted_26,
          _createVNode("div", _hoisted_27, _toDisplayString(_ctx.updatedAt), 1),
          _createVNode("div", _hoisted_28, _toDisplayString(_ctx.ursaCodeDetailData.updatedByName || "-"), 1)
        ]),
        _createVNode("div", _hoisted_29, [
          _hoisted_30,
          _hoisted_31,
          _createVNode(_component_ToggleV2, {
            modelValue: _ctx.ursaCodeDetailData.isActive,
            "onUpdate:modelValue": _ctx.updateUrsaStatus
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "onBack", "loading", "error", "errorType", "onTryAgain"]))
})